export default class Localisation {
    constructor(_cb = () => {}, _cbError = () => {}, _cbContext = undefined) {
        this.localisationOptions = {
            enableHighAccuracy: true,
            timeout: 5000,
            maximumAge: 0
        };

        this.cbContext = _cbContext;
        this.cb = _cb;
        this.cbError = _cbError
    }

    updatePosition() {
        var self = this;

        function success(pos) {
            var crd = pos.coords;
            self.accuracy = crd.accuracy;
            if(self.cbContext) {
                self.cb(self.cbContext, {
                    latitude: crd.latitude,
                    longitude: crd.longitude,
                    accuracy: crd.accuracy,
                    speed: crd.speed
                });
            }
            else {
                self.cb({
                    latitude: crd.latitude,
                    longitude: crd.longitude,
                    accuracy: crd.accuracy,
                    speed: crd.speed
                });
            }
        }
        
        function error(err) {
            self.cbError(err)
        }      

        navigator.geolocation.getCurrentPosition(success, error, this.localisationOptions);
    }

    activate(_refreshTime, _withUpdate = true) {
        var self = this;

        this.refreshTime = _refreshTime;

        if(_withUpdate) {
            this.updatePosition();
        }

        this.interval = setInterval(() => {
            self.updatePosition();
        }, _refreshTime)
    }

    deactivate() {
        clearInterval(this.interval);
        delete this.accuracy
    }

    setRefreshTime(_time) {
        this.deactivate();
        this.activate(_time, false);
    }

    getRefreshTime() {
        return this.refreshTime
    }

    getAccuracy() {
        return this.accuracy;
    }

    distance(lat1, lon1, lat2, lon2, unit) {
        var radlat1 = Math.PI * lat1/180
        var radlat2 = Math.PI * lat2/180
        var theta = lon1-lon2
        var radtheta = Math.PI * theta/180
        var dist = Math.sin(radlat1) * Math.sin(radlat2) + Math.cos(radlat1) * Math.cos(radlat2) * Math.cos(radtheta);
        dist = Math.acos(dist)
        dist = dist * 180/Math.PI
        dist = dist * 60 * 1.1515

        switch(unit) {
            case 'M':
                return dist * 1609.344
            case 'K':
                return dist * 1.609344
            case 'N':
                return dist * 0.8684
            default:
                return dist
        }
    }
}